'use es6';

import { Component } from 'react';
import AdjacentPortal from './AdjacentPortal';

/**
 * @param {Object} props
 * @param {string} props.id (required)
 * @param {string} [props.namespace] (optional)
 * @param {Element} props.targetElement (required)
 * @param {React.ReactNode} props.children (required)
 * @param {Object} [props.dataAttributes] (optional)
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default class AfterBeginPortal extends Component {
  render() {
    const {
      id,
      namespace,
      targetElement,
      children,
      dataAttributes
    } = this.props;
    return /*#__PURE__*/_jsx(AdjacentPortal, {
      id: id,
      namespace: namespace,
      targetElement: targetElement,
      targetPosition: 'afterbegin',
      dataAttributes: dataAttributes,
      children: children
    });
  }
}